/**
 * Sprint windows for the DGR leaderboard.
 *
 * Each sprint defines a date-bounded period during which the "sprint mode"
 * leaderboard re-ranks participants by donations received in the window.
 *
 * Bucket dates are UTC (YYYY-MM-DD) and inclusive on both ends — they map
 * directly onto `donation_rollups_entrant.fx_bucket` (a daily UTC date).
 */
export interface SprintDefinition {
  id: string;
  label: string;
  /** Optional prize/sponsor headline shown in the sprint bar. */
  prize?: string;
  bucketStart: string;
  bucketEnd: string;
  /** ISO timestamp the sprint window opens. */
  startsAt: string;
  /** ISO timestamp the sprint window closes (drives the countdown). */
  endsAt: string;
}

export const SPRINTS: SprintDefinition[] = [
  {
    id: 'sprint-1',
    label: 'Sprint 1',
    bucketStart: '2026-04-14',
    bucketEnd: '2026-04-20',
    startsAt: '2026-04-14T00:00:00Z',
    endsAt: '2026-04-20T23:59:00Z',
  },
  {
    id: 'sprint-2',
    label: 'Sprint 2',
    prize: 'Quad Lock prize pack',
    bucketStart: '2026-04-27',
    bucketEnd: '2026-05-03',
    startsAt: '2026-04-27T00:01:00Z',
    endsAt: '2026-05-03T23:59:00Z',
  },
  {
    id: 'sprint-3',
    label: 'Sprint 3',
    prize: 'BRETT Eyewear',
    bucketStart: '2026-05-10',
    bucketEnd: '2026-05-16',
    startsAt: '2026-05-10T00:00:01Z',
    endsAt: '2026-05-16T23:59:00Z',
  },
];

/**
 * Pick the sprint to default to: an in-progress sprint if one exists,
 * otherwise the next upcoming, otherwise the most recent past sprint.
 */
export function getDefaultSprintId(now: Date = new Date()): string {
  const ms = now.getTime();
  const ongoing = SPRINTS.find(
    (s) => ms >= new Date(s.startsAt).getTime() && ms <= new Date(s.endsAt).getTime(),
  );
  if (ongoing) return ongoing.id;
  const upcoming = [...SPRINTS]
    .filter((s) => new Date(s.startsAt).getTime() > ms)
    .sort((a, b) => new Date(a.startsAt).getTime() - new Date(b.startsAt).getTime())[0];
  if (upcoming) return upcoming.id;
  return SPRINTS[SPRINTS.length - 1].id;
}
